import { DatePicker } from 'antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import dayjs, { extend } from 'dayjs'
import utcPlugin from 'dayjs/plugin/utc'
import type { FC } from 'react'
import type { DateRangeSchema } from '../schemas'
import { addUtcOffset, minusUtcOffset } from '../utils'

extend(utcPlugin)

interface UnixRangePickerProps extends Pick<DateRangeSchema, 'utc' | 'showTime' | 'allowEmpty'> {
  value?: [number | null, number | null]
  onChange?: (value?: [number | null, number | null]) => void
}

const UnixRangePicker: FC<UnixRangePickerProps> = props => {
  const { value, onChange, utc, ...rest } = props

  const internelValue: RangePickerProps['value'] = [
    value?.[0] ? (utc ? minusUtcOffset(dayjs(value[0] * 1000)) : dayjs(value[0] * 1000)) : null,
    value?.[1] ? (utc ? minusUtcOffset(dayjs(value[1] * 1000)) : dayjs(value[1] * 1000)) : null,
  ]

  const onChangeHandler: RangePickerProps['onChange'] = range => {
    onChange?.([
      range?.[0] ? (utc ? addUtcOffset(range[0]).unix() : range[0].unix()) : null,
      range?.[1] ? (utc ? addUtcOffset(range[1]).unix() : range[1].unix()) : null,
    ])
  }

  return <DatePicker.RangePicker {...rest} value={internelValue} onChange={onChangeHandler} />
}

export default UnixRangePicker
